import { reviews } from "../../../mocks/guaData";
import Reveal from "./Reveal";
import SectionHead from "./SectionHead";

const principles = [
  { icon: "ri-eye-2-line", title: "客观还原", desc: "只从传播机制出发描述现象，不以立场代替事实。" },
  { icon: "ri-shield-check-line", title: "不造谣", desc: "不制造、不扩散未经核实的信息，尊重真实个体。" },
  { icon: "ri-search-line", title: "多方核实", desc: "还原争议前，尽量对照事件不同侧面的说法。" },
  { icon: "ri-lightbulb-flash-line", title: "理性吃瓜", desc: "倡导克制表达，拒绝以围观之名行伤害之实。" },
];

export default function About() {
  return (
    <section id="about" className="bg-background-50 py-16 md:py-20">
      <div className="mx-auto max-w-[1200px] px-4 md:px-6">
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              "@context": "https://schema.org",
              "@type": "AboutPage",
              name: "关于吃瓜透视局",
              description: "吃瓜透视局专注吃瓜事件营销、背后推手、炒作真相与舆论引导的现象级分析。",
              publisher: { "@type": "Organization", name: "吃瓜透视局" },
            }),
          }}
        />
        <div className="grid items-center gap-10 lg:grid-cols-2 lg:gap-14">
          <Reveal>
            <div className="overflow-hidden rounded-2xl border border-background-200 bg-background-100">
              <img
                src="https://readdy.ai/api/search-image?query=editorial%20vintage%20flat%20illustration%20of%20a%20team%20of%20curious%20researchers%20magnifying%20glass%20and%20documents%20examining%20a%20large%20glowing%20newspaper%2C%20warm%20cream%20background%20terracotta%20red%20and%20golden%20amber%2C%20hand%20drawn%20grains%2C%20vintage%20print%20poster%20aesthetic%2C%20high%20detail&width=880&height=760&seq=gua-about-2026&orientation=portrait"
                alt="吃瓜透视局的传播研究团队插画"
                title="吃瓜透视局 - 传播现象观察"
                className="h-full w-full object-cover"
              />
            </div>
          </Reveal>

          <div>
            <SectionHead
              eyebrow="关于我们 · 品牌定位"
              title={
                <>
                  我们不是「爆料号」，
                  <br />
                  而是传播现象的<span className="text-primary-500">观察站</span>
                </>
              }
              desc="吃瓜透视局是一个关注热点传播机制的内容站。我们不做没有依据的爆料，也不消费真实个体，只把「事件营销、幕后推手、舆论引导、真相核查」这四件事讲明白，帮大家理性地看待每一场热闹。"
            />
            <div className="grid gap-3 sm:grid-cols-2">
              {principles.map((p, i) => (
                <Reveal key={p.title} delay={i * 70}>
                  <div className="flex items-start gap-3 rounded-lg border border-background-200 bg-background-100 p-4">
                    <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-md bg-primary-100 text-primary-600">
                      <i className={`${p.icon} text-lg`} aria-hidden="true"></i>
                    </span>
                    <div>
                      <p className="font-heading text-sm font-bold text-foreground-900">{p.title}</p>
                      <p className="mt-1 text-xs leading-relaxed text-foreground-600">{p.desc}</p>
                    </div>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-14">
          <Reveal>
            <p className="mb-6 text-center font-heading text-2xl font-black text-foreground-950">
              理性吃瓜路上的同行者怎么说
            </p>
          </Reveal>
          <div className="grid gap-5 md:grid-cols-3">
            {reviews.map((r, i) => (
              <Reveal key={r.name} delay={i * 80}>
                <figure className="flex h-full flex-col rounded-xl border border-background-200 bg-background-100 p-6">
                  <div className="flex gap-0.5 text-accent-500" aria-hidden="true">
                    {Array.from({ length: 5 }).map((_, j) => (
                      <i key={j} className="ri-star-fill"></i>
                    ))}
                  </div>
                  <blockquote className="mt-4 flex-1 text-sm leading-relaxed text-foreground-700">
                    “{r.quote}”
                  </blockquote>
                  <figcaption className="mt-5 border-t border-background-200 pt-4">
                    <p className="font-heading text-sm font-bold text-foreground-900">{r.name}</p>
                    <p className="mt-0.5 text-xs text-foreground-500">{r.role}</p>
                  </figcaption>
                </figure>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}